import { render, staticRenderFns } from "./locked.vue?vue&type=template&id=353391a0&scoped=true&"
import script from "./locked.vue?vue&type=script&lang=ts&"
export * from "./locked.vue?vue&type=script&lang=ts&"
import style0 from "./locked.vue?vue&type=style&index=0&id=353391a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353391a0",
  null
  
)

export default component.exports